import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function SettingsStore({ children }) {
  useInjectSaga({ key: 'settingsStore', saga });
  useInjectReducer({ key: 'settingsStore', reducer });

  return React.Children.only(children);
}

SettingsStore.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withSettingsStore } from './withSettingsStore';
export default compose(withConnect, memo)(SettingsStore);
